export const PortfolioKeys = {
	all: ["portfolio"] as const,
	portfolioList: (
		filterDatagroups?: string[],
		filterOnlyreportingenabled?: boolean,
	) =>
		[
			...PortfolioKeys.all,
			"portfolio-list",
			...(filterDatagroups ?? []),
			filterOnlyreportingenabled,
		] as const,
	propertyList: (
		filterDatagroups?: string[],
		filterOnlyreportingenabled?: boolean,
	) =>
		[
			...PortfolioKeys.all,
			"property-list",
			...(filterDatagroups ?? []),
			filterOnlyreportingenabled,
		] as const,
	portfolioDetail: (id: number) =>
		[...PortfolioKeys.all, "portfolio-detail", id] as const,
	propertyDetail: (id: number) =>
		[...PortfolioKeys.all, "property-detail", id] as const,
	reporting: (id: number) => [...PortfolioKeys.all, "reporting", id] as const,
	reportingSummary: (
		filterPortfolioids?: number[],
		filterDatagroups?: string[],
	) =>
		[
			...PortfolioKeys.all,
			"reporting-summary",
			...(filterPortfolioids ?? []),
			...(filterDatagroups ?? []),
		] as const,
	documents: (id: number) => [...PortfolioKeys.all, "documents", id] as const,
	productCategories: (portfolioArea: string) =>
		[...PortfolioKeys.all, "product-categories", portfolioArea] as const,
};
